import {
    DataHygieneStatus,
    StatusProps,
} from 'assets/js/pages/contacts/data-hygiene/DataHygieneStatus';
import { EmailDeliverabilityStatus } from 'types/domain';

interface EmailStatusProps {
    status: EmailDeliverabilityStatus;
}

const EmailStatus = ({ status }: EmailStatusProps) => {
    const statusMatch: StatusProps = getEmailStatusProps(status);

    if (!statusMatch) {
        return null;
    }

    return <DataHygieneStatus status={statusMatch} />;
};

const HELP_TEXT = {
    DELIVERABLE: `This email address is deliverable and will reach the intended recipient.`,
    UNDELIVERABLE: `This email is either not deliverable or it is a disposable email. It may not be deliverable because it includes wrong information, such as a string without a domain or containing other errors, or the email does not exist.`,
    BOUNCED: `A bounced email address is due to either the recipient's inbox being full, the email being blocked by the recipient, or the domain not existing.`,
};

const getEmailStatusProps = (status: EmailDeliverabilityStatus) => {
    switch (status) {
        case 'deliverable':
            return {
                displayText: 'Deliverable',
                dotColor: 'bg-green-500',
                tooltipText: HELP_TEXT.DELIVERABLE,
            };
        case 'undeliverable': /* falls through */
        case 'disposable':
            return {
                displayText: 'Invalid email',
                dotColor: 'bg-red-500',
                tooltipText: HELP_TEXT.UNDELIVERABLE,
            };
        case 'bounced':
            return {
                displayText: 'Bounced email',
                dotColor: 'bg-orange-500',
                tooltipText: HELP_TEXT.BOUNCED,
            };
    }
};

export { EmailStatus };
